import { type RouteRecordRaw } from 'vue-router'

export default [
  // domeos
  {
    path: '/domeos',
    component: () => import('../modules/domeos/layout.vue'),
    meta: {
      title: 'DomeOS',
      showTabs: true,
      tabs: [
        { path: '/domeos', name: '概览', key: 'overview' },
        { path: '/domeos/projects', name: '项目', key: 'projects' },
        { path: '/domeos/services', name: '服务', key: 'services' },
        { path: '/domeos/packages', name: '资源包', key: 'packages' }
      ]
    },
    children: [
      // DomeOS 概览
      {
        path: '',
        name: 'DomeOS',
        component: () => import('../modules/domeos/overview.vue'),
        meta: { activeTab: 'overview' }
      },
      // 项目
      {
        path: 'projects',
        name: 'DomeOSProjects',
        component: () => import('../modules/domeos/projects.vue'),
        meta: { activeTab: 'projects' }
      },
      // 服务
      {
        path: 'services',
        name: 'DomeOSServices',
        component: () => import('../modules/domeos/services.vue'),
        meta: { activeTab: 'services' }
      },
      // 资源包
      {
        path: 'packages',
        name: 'DomeOSPackages',
        component: () => import('../modules/domeos/packages.vue'),
        meta: { activeTab: 'packages' }
      },
      // 工程列表页面（使用DomeOS layout但不显示标签页）
      {
        path: '/domeos/engineering-list/:projectId',
        name: 'DomeOSEngineeringList',
        component: () => import('../modules/domeos/engineering-list.vue'),
        meta: {
          title: '工程',
          showTabs: false
        }
      },
      // 构建记录页面（使用DomeOS layout但不显示标签页）
      {
        path: '/domeos/building-record/:projectId/:engineeringId',
        name: 'DomeOSBuildingRecord',
        component: () => import('../modules/domeos/building-record.vue'),
        meta: {
          title: '构建记录',
          showTabs: false
        }
      },
      // 部署记录页面（使用DomeOS layout但不显示标签页）
      {
        path: '/domeos/deployment/:serviceId',
        name: 'DomeOSDeployment',
        component: () => import('../modules/domeos/deployment.vue'),
        meta: {
          title: '部署记录',
          showTabs: false
        }
      },

      // 主机列表页面（使用DomeOS layout但不显示标签页）
      {
        path: '/domeos/hosts/:resourcePackageId',
        name: 'DomeOSHostList',
        component: () => import('../modules/domeos/host-list.vue'),
        meta: {
          title: '主机列表',
          showTabs: false
        }
      },
      // 异常部署列表页面（使用DomeOS layout但不显示标签页）
      {
        path: '/domeos/exception-deployments',
        name: 'DomeOSExceptionDeployments',
        component: () => import('../modules/domeos/exception-deployments.vue'),
        meta: {
          title: '异常部署',
          showTabs: false
        }
      },
      // 主机详情页面（使用DomeOS layout显示标签页）
      {
        path: '/domeos/host/:resourcePackageId/:hostId',
        name: 'DomeOSHostDetail',
        meta: {
          title: '主机详情', // 这里会被动态替换为主机名称
          showTabs: true,
          tabs: [
            {
              path: '/domeos/host/:resourcePackageId/:hostId',
              name: '详情',
              key: 'details'
            },
            {
              path: '/domeos/host/:resourcePackageId/:hostId/labels',
              name: '标签',
              key: 'labels'
            },
            {
              path: '/domeos/host/:resourcePackageId/:hostId/monitoring',
              name: '监控',
              key: 'monitoring'
            }
          ]
        },
        children: [
          // 主机详情
          {
            path: '',
            name: 'DomeOSHostDetails',
            component: () => import('../modules/domeos/host/host-details.vue'),
            meta: { activeTab: 'details' }
          },
          // 主机标签
          {
            path: 'labels',
            name: 'DomeOSHostLabels',
            component: () => import('../modules/domeos/host/host-labels.vue'),
            meta: { activeTab: 'labels' }
          },
          // 主机标签编辑（不展示顶部标签页）
          {
            path: 'labels/edit',
            name: 'DomeOSHostLabelsEdit',
            component: () =>
              import('../modules/domeos/host/host-labels-edit.vue'),
            meta: { title: '编辑主机标签', showTabs: false }
          },
          // 主机监控
          {
            path: 'monitoring',
            name: 'DomeOSHostMonitoring',
            component: () =>
              import('../modules/domeos/host/host-monitoring.vue'),
            meta: { activeTab: 'monitoring' }
          }
        ]
      },
      // 部署详情页面（使用DomeOS layout显示标签页）
      {
        path: '/domeos/deploy/:serviceId/:deploymentId',
        name: 'DomeOSDeployDetail',
        // component: () => import('../modules/domeos/layout.vue'),
        meta: {
          title: '部署详情', // 这里会被动态替换为部署名称
          showTabs: true,
          tabs: [
            {
              path: '/domeos/deploy/:serviceId/:deploymentId',
              name: '部署详情',
              key: 'details'
            },
            {
              path: '/domeos/deploy/:serviceId/:deploymentId/versions',
              name: '版本列表',
              key: 'versions'
            },
            {
              path: '/domeos/deploy/:serviceId/:deploymentId/instances',
              name: '实例列表',
              key: 'instances'
            },
            {
              path: '/domeos/deploy/:serviceId/:deploymentId/history',
              name: '升级历史',
              key: 'history'
            },
            {
              path: '/domeos/deploy/:serviceId/:deploymentId/monitoring',
              name: '实例监控',
              key: 'monitoring'
            }
          ]
        },
        children: [
          // 部署详情
          {
            path: '',
            name: 'DomeOSDeployDetails',
            component: () =>
              import('../modules/domeos/deploy/deploy-details.vue'),
            meta: { activeTab: 'details' }
          },
          // 版本列表
          {
            path: 'versions',
            name: 'DomeOSDeployVersions',
            component: () =>
              import('../modules/domeos/deploy/version-list.vue'),
            meta: { activeTab: 'versions' }
          },
          // 实例列表
          {
            path: 'instances',
            name: 'DomeOSDeployInstances',
            component: () =>
              import('../modules/domeos/deploy/instance-list.vue'),
            meta: { activeTab: 'instances' }
          },
          // 升级历史
          {
            path: 'history',
            name: 'DomeOSDeployHistory',
            component: () =>
              import('../modules/domeos/deploy/upgrade-history.vue'),
            meta: { activeTab: 'history' }
          },
          // 实例监控
          {
            path: 'monitoring',
            name: 'DomeOSDeployMonitoring',
            component: () =>
              import('../modules/domeos/deploy/instance-monitoring.vue'),
            meta: { activeTab: 'monitoring' }
          },
          // 部署升级页面
          {
            path: 'upgrade',
            name: 'DomeOSDeployUpgrade',
            component: () =>
              import('../modules/domeos/deploy/deploy-upgrade.vue'),
            meta: {
              title: '部署升级',
              showTabs: false
            }
          },
          {
            path: 'start',
            name: 'DomeOSDeployStart',
            component: () =>
              import('../modules/domeos/deploy/deploy-start.vue'),
            meta: {
              mode: 'start',
              title: '部署启动',
              showTabs: false
            }
          }
        ]
      },
      // 版本详情页面（独立页面，不显示标签页）
      {
        path: '/domeos/deploy/:serviceId/:deploymentId/version/:versionId',
        name: 'DomeOSVersionDetails',
        component: () => import('../modules/domeos/deploy/version-details.vue'),
        meta: {
          title: '版本详情',
          showTabs: false
        }
      },
      // 新版本创建页面（独立页面，不显示标签页）
      {
        path: '/domeos/deploy/:serviceId/:deploymentId/version/create',
        name: 'DomeOSVersionCreate',
        component: () => import('../modules/domeos/deploy/version-create.vue'),
        meta: {
          title: '创建新版本',
          showTabs: false
        }
      }
    ]
  }
] satisfies RouteRecordRaw[]
